const holdsMessages = (messages) => {
  let messageBag = messages ? { ...messages } : {};
  return {
    clear(key) {
      delete messageBag[key];
      return messageBag;
    },
    getMessageCount() {
      return Object.keys(messageBag).length;
    },
    getMessage(key) {
      return messageBag[key];
    },
    getMessages() {
      return messageBag;
    },
    update(key, message) {
      messageBag = {
        ...messageBag,
        [key]: message,
      };
      return messageBag;
    },
  };
};

export default holdsMessages;
